import { gql } from '@apollo/client';

export const GET_FRANCHISE_DELIVERY_COSTS = gql`
  query EdmundsQuery(
    $franchiseIds: [Int!]!
    $pageNum: Int!
    $pageSize: Int!
    $userStateCode: String!
    $userLat: Float!
    $userLon: Float!
    $userDma: String!
  ) {
    franchiseDealers(filters: { page: { pageNum: $pageNum, pageSize: $pageSize }, franchiseIds: $franchiseIds }) {
      dealers {
        id
        deliveryCost(
          userLocationFilter: { userStateCode: $userStateCode, userLat: $userLat, userLon: $userLon, userDma: $userDma }
        ) {
          deliveryType
          finalDeliveryCost
          model
          ... on StoreToStoreDeliveryCost {
            finalDeliveryCost
          }
          ... on RegionDeliveryCost {
            finalDeliveryCost
          }
          ... on DistanceDeliveryCost {
            finalDeliveryCost
          }
          ... on DmaDeliveryCost {
            finalDeliveryCost
          }
          ... on TierDeliveryCost {
            finalDeliveryCost
          }
        }
      }
    }
  }
`;
